const form = {
  formId: "new-user-form",
  formField: {
    nameOfProductionBusinessActivities: {
      name: "nameOfProductionBusinessActivities",
      label: "[01a] Mã hồ sơ khai dự án đầu tư:",
      type: "text",
      placeholder: "Hoạt động sản xuất kinh doanh thông thường",
      errorMsg: "Vui lòng nhập tên hoạt động sản xuất",
    },
    taxCalculationPeriod: {
      name: "taxCalculationPeriod",
      label: "[01b] Kỳ tính thuế:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu:",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    taxpayerName: {
      name: "taxpayerName",
      label: "[04] Tên người nộp thuế",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxId: {
      name: "taxId",
      label: "[05] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    projectName: {
      name: "projectName",
      label: "[06] Tên dự án đầu tư:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên dự án đầu tư",
    },
    addressActive: {
      name: "addressActive",
      label: "[07] Địa chỉ thực hiện dự án đầu tư (Số nhà, đường phố):",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ thực hiện dự án đầu tư",
    },
    addressWard: {
      name: "addressWard",
      label: "[08] Phường/Xã:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập Phường/Xã",
    },
    addressDistrict: {
      name: "addressDistrict",
      label: "[09] Quận/Huyện:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập Quận/Huyện",
    },
    addressCity: {
      name: "addressCity",
      label: "[10] Tỉnh/Thành phố:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập Tỉnh/Thành phố",
    },
    contract: {
      name: "contract",
      label: "[11] Văn bản phê duyệt dự án đầu tư: Số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên đơn vị phụ thuộc/địa điểm kinh doanh",
    },
    projectDay: {
      name: "projectDay",
      label: "Ngày",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày",
    },
    projectOf: {
      name: "projectOf",
      label: "của ",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập cơ quan ban hành",
    },
    taxAgentName: {
      name: "taxAgentName",
      label: "[12] Tên chủ dự án đầu tư:",
      errorMsg: "Vui lòng nhập tên chủ dự án",
      type: "text",
      placeholder: "",
    },
    taxAgentId: {
      name: "taxAgentId",
      label: "[13] Mã số thuế chủ dự án:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst chủ dự án",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    taxAgencyName: {
      name: "taxAgencyName",
      label: "[14] Tên đại lý thuế (nếu có)",
      type: "text",
      placeholder: "",
    },
    taxAgencyId: {
      name: "taxAgencyId",
      label: "[15] Mã số thuế đại lý:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    contractNumber: {
      name: "contractNumber",
      label: "[16] Hợp đồng đại lý thuế: Số:",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập số hợp đồng đại lý thuế",
      invalidMsg: "Mã số hợp đồng đại lý thuế không hợp lệ",
    },
    contractDay: {
      name: "contractDay",
      label: "Ngày:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn ngày hợp đồng tính thuế",
    },
    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
